











import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Zone from '@/dto/Zone/Zone'
import ZonesTable from '@/components/delivery/zones/ZonesTable.vue'
import zoneStore from '@/stores/ZoneStore'
import Delivery from '@/dto/deliveries/Delivery'
import ZoneItems from '@/components/delivery/zone-items/ZoneItems.vue'

@Component({
  components: { ZoneItems, ZonesTable },
})
export default class Zones extends Vue {
  @Prop(Object)
  model: Delivery
  isPending: boolean = false
  zoneStore = zoneStore

  get zones(): Zone[] {
    return this.zoneStore.zones
  }

  @Watch('model', { immediate: true })
  async loadZones() {
    this.zoneStore.selectZone(null)
    if (this.zones.length) {
      this.zoneStore.setZones([])
    }

    this.isPending = true
    await this.zoneStore.loadZones()
    this.isPending = false
  }
}
